import React, { FC, useState } from 'react';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';

interface DeleteBulkRepProps {
  show: boolean;
  onClose: (refetchData?: boolean) => void;
  data: any;
}

interface DeleteBulkRepFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteBulkRepFooter: FC<DeleteBulkRepFooterProps> = ({ onCancel, onConfirm, loading }) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>

    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const DeleteBulkRep: FC<DeleteBulkRepProps> = ({ show, onClose, data }) => {
  const [loading, setLoading] = useState(false);

  const DeleteRep = async () => {
    setLoading(true);
    try {
      const res = await apiService.post(`cs/staff/delete`, {
        data: {
          user_ids: data
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      if (res?.data) {
        toast(<ToastMessage type='success' message='cs reps deleted successfully' />);
        onClose(true);
      }
    } catch {
      toast(<ToastMessage type='error' message='Error occured while deleting cs rep' />);
    }
    setLoading(false);
  };

  return (
    <BaseModal
      isOpen={show}
      title=''
      description={`Are you sure you want to delete items`}
      titleIcon={<DeleteIcon className='text-red-5' />}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <DeleteBulkRepFooter loading={loading} onCancel={() => onClose()} onConfirm={DeleteRep} />
      }
    />
  );
};

export default DeleteBulkRep;
